// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7cec19ce","239":"e97b088c","455":"a6366c54","938":"97406239"}[chunkId] + ".chunk.js";
};